export default __webpack_public_path__ + "media/images/icon_settings-74168dac7dc1d00faef7057179afaf38.png";